import { Grid, Box, Card, TableContainer } from "@mui/material";
import Indexdasboard from "../../components/dashboard/IndexDashbord";
import TitreGraphik from "../../components/Typography/TitreGraphik";
import { useParams, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import LabelTypography from "../../components/Typography/LabelTypography";
import { useEffect, useState } from "react";
import { Api_Token } from "../../util/Api";
import BookingsTransactionPayment from "../../components/BookingTransaction/BookingsTransactionPayment";
import NumericFormatEnv from "../../components/Numeric/NumericFormatEnv";
import { formatDateTime } from "../../services/functions";

export default function DetaillTransactionPage() {
  return <Indexdasboard Children={<DetaillTransaction />} />;
}

function DetaillTransaction() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [transaction, setTransaction] = useState(null);
  const [bookingsPaiments, setBookingsPaiments] = useState(null);

  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        const response = await Api_Token.get(
          `transaction/getTransactionDetaill/${id}`
        );
        setTransaction(response.data.transaction);
        setBookingsPaiments(response.data.booking_paiement);
      } catch (err) {
        console.log("Error fetching transaction data");
      }
    };

    fetchTransaction();
  }, [id]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TitreGraphik>
            <span onClick={() => navigate(-1)}>⬅</span>
            {t("Transaction detaill id : {{id}}", { id })}
          </TitreGraphik>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <Card sx={{ height: "100%", padding: "2%" }}>
                <LabelTypography>{t("Caisse Name : ")}</LabelTypography>
                <LabelTypography>
                  {transaction?.caisse_journey.caisse?.nomCaisse}
                </LabelTypography>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{ height: "100%", padding: "2%" }}>
                <LabelTypography>{t("Total Amount : ")}</LabelTypography>
                <LabelTypography>
                  <NumericFormatEnv Number={transaction?.montant} />
                </LabelTypography>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{ height: "100%", padding: "2%" }}>
                <LabelTypography>{t("Payment Method : ")}</LabelTypography>
                <LabelTypography>{transaction?.payment_method}</LabelTypography>
              </Card>
            </Grid>
            <Grid item xs={12} md={3}>
              <Card sx={{ height: "100%", padding: "2%" }}>
                <LabelTypography>{t("Date Created  : ")}</LabelTypography>
                <LabelTypography>
                  {formatDateTime(transaction?.created_at)}
                </LabelTypography>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TitreGraphik>{t("Booking Payments")}</TitreGraphik>
            </Grid>
            <Grid item xs={12}>
              <Card sx={{ padding: "2%" }}>
                <TableContainer sx={{ marginTop: "20px" }}>
                  <BookingsTransactionPayment
                    bookings={bookingsPaiments}
                    listAffiche={["idBookings", "Montant", "payment method"]}
                    typePayment={transaction?.payment_method}
                  />
                </TableContainer>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
